import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useMetaDescription } from '@/hooks/useMetaDescription';
import { usePetNotifications } from '@/hooks/usePetNotifications';
import { AllNotifications } from '@/components/notifications';
import { DebugLauncher } from '@/components/debug/DebugLauncher';
import { SystemDebugger } from '@/components/SystemDebugger';
import { Toaster } from '@/components/ui/sonner';
import { AppRoutes } from './AppRoutes';

export function AppLayout() {
  const { user } = useAuth();
  
  // Initialize app-wide hooks
  useMetaDescription();
  usePetNotifications();

  if (import.meta.env.DEV) {
    console.log('🔍 AppLayout - User:', user ? 'authenticated' : 'not authenticated');
    console.log('🔍 Current pathname:', window.location.pathname);
  }

  return (
    <>
      <div className="app-container">
        <AppRoutes />
        <AllNotifications />
        <DebugLauncher />
        <SystemDebugger />
      </div>
      <Toaster
        richColors
        position="top-center"
        closeButton
        style={{ zIndex: 2147483647 }} 
      />
    </>
  );
}